<template>
  <div class="logDiv">
    <img :src="logoUrl"/>
  </div>
</template>

<script>
  import logoUrl from '@/assets/logo.png'

  export default {
    name: 'Logo',
    components: {
    },
    props: {
      title: {
        type: String,
        default: 'BMS',
        required: false
      },
      showTitle: {
        type: Boolean,
        default: true,
        required: false
      }
    },
    data () {
      return {
        logoUrl
      }
    }
  }
</script>
<style scoped lang="less">
  .title {
    color: #fff !important;
  }

  .logDiv {
    background: #454341;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 9;
    top: 0;
    left: 0;
    width: 180px;
    img{
      height: 33px;
    }
  }
</style>
